// src/data/fishIQRegionalSpeciesRegistry.ts
// Region-specific FishIQ species registry.
// This intentionally avoids a generic "Asia" pack so future UI/search/ranking can
// reason from the specific regional pack selected by the detector.
import type { FishIQSpeciesSeed } from '../types';
import { THAILAND_FISHIQ_SPECIES_SEED } from './regions/fishIQThailandSpecies';
import { PHILIPPINES_FISHIQ_SPECIES_SEED } from './regions/fishIQPhilippinesSpecies';
import { INDONESIA_FISHIQ_SPECIES_SEED } from './regions/fishIQIndonesiaSpecies';
import { INDIA_FISHIQ_SPECIES_SEED } from './regions/fishIQIndiaSpecies';

import {
  THAILAND_FISHIQ_SPECIES_BUFF_V2_SEED,
  PHILIPPINES_FISHIQ_SPECIES_BUFF_V2_SEED,
  INDONESIA_FISHIQ_SPECIES_BUFF_V2_SEED,
} from './regions/fishIQSeaSpecies';

import {

  US_FISHIQ_SPECIES_BUFF_V2_SEED,
} from './regions/fishIQUnitedStatesSpecies';

export type FishIQRegionalSpeciesPackId = 'united_states' | 'thailand' | 'philippines' | 'indonesia' | 'india';

export type FishIQRegionalSpeciesPack = {
  id: FishIQRegionalSpeciesPackId;
  label: string;
  species: FishIQSpeciesSeed[];
};

export const FISHIQ_REGIONAL_SPECIES_PACKS: Record<FishIQRegionalSpeciesPackId, FishIQRegionalSpeciesPack> = {
  united_states: {
    id: 'united_states',
    label: 'United States',
    species: [
    
      ...US_FISHIQ_SPECIES_BUFF_V2_SEED,
    ],
  },
  thailand: {
    id: 'thailand',
    label: 'Thailand',
    species: [
      ...THAILAND_FISHIQ_SPECIES_SEED,
      ...THAILAND_FISHIQ_SPECIES_BUFF_V2_SEED,
    ],
  },
  philippines: {
    id: 'philippines',
    label: 'Philippines',
    species: [
      ...PHILIPPINES_FISHIQ_SPECIES_SEED,
      ...PHILIPPINES_FISHIQ_SPECIES_BUFF_V2_SEED,
    ],
  },
  indonesia: {
    id: 'indonesia',
    label: 'Indonesia',
    species: [
      ...INDONESIA_FISHIQ_SPECIES_SEED,
      ...INDONESIA_FISHIQ_SPECIES_BUFF_V2_SEED,
    ],
  },
  india: {
    id: 'india',
    label: 'India',
    species: [
      ...INDIA_FISHIQ_SPECIES_SEED,
    ],
  },
};

export const FISHIQ_REGIONAL_SPECIES_SEED: FishIQSpeciesSeed[] = Object.values(FISHIQ_REGIONAL_SPECIES_PACKS)
  .flatMap((pack) => pack.species);

export function getFishIQRegionalSpeciesPack(id: string | null | undefined): FishIQRegionalSpeciesPack | null {
  const key = String(id || '').trim().toLowerCase() as FishIQRegionalSpeciesPackId;
  return FISHIQ_REGIONAL_SPECIES_PACKS[key] || null;
}
